
<div class="rewardsContent">
        <div class="rewardsContentHeader">
            <div class="typography-title-xl"> {{ 'rewards.subtitle' | translate }}</div>
        </div>
        <div class="rewardsContentBody">

            <!-- A global community, a unique experience -->
            <div class="sectionContainer section4">
                <div class="headerSection">
                    <div class="typography-title-l">{{ 'benefits_we.una_comunidad' | translate }}</div>
                </div>
                <div class="bodySectionRow">
                    <div class="bodyDescription50">
                        <div class="typography-body-l-regular">
							{{ 'rewards.block1_text1' | translate }}
						</div>
                        <div class="typography-body-l-regular">
							{{ 'rewards.block1_text2' | translate }}
						</div>
                    </div>
                    <div class="bodyImage">
                        <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/We-Significa-DT.png" alt="We Professionals visual" />
                    </div>
                </div>
            </div>

            <div class="spaceBetween"></div>

            <!-- How does ‘We Professionals’ work? -->
            <div class="sectionContainer">
                <div class="headerSection">
                    <div class="typography-title-l">
						{{ 'benefits_we.como_funciona' | translate }}
					</div>
                </div>
                <div class="bodySectionColumn">
                    <div class="bodyDescription100">
                        <div class="typography-body-l-regular text-justify">
                            {{ 'rewards.block2_text1' | translate }}
                        </div>
                        <div class="typography-body-l-medium pb-6">
                          {{ 'rewards.block2_text2' | translate }}
                        </div>
                    </div>
                    <div class="boydCardContent">
                        <div class="cardContent">
                            <div class="cardImage">
                                <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/beneficios-dt-ADV.png" alt="Advanced tier" />
                            </div>
                            <div class="cardDescription backAdvanced">
                                <div class="uppercase typography-title-l">
									{{ 'benefits_we.pro' | translate }}
								</div>
                                <div class="typography-body-l-regular">
									{{ 'benefits_we.al_acceder_a_nuestra_plataforma' | translate }}
								</div>
                            </div>
                        </div>
                        <div class="cardContent eliteContent">
                            <div class="cardDescription backElite">
                                <div class="uppercase typography-title-l">
									{{ 'benefits_we.elite' | translate }}
								</div>
                                <div class="typography-body-l-regular">
									{{ 'benefits_we.benefits_elite_kb' | translate }}
								</div>
                            </div>
                            <div class="cardImage">
                                <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/beneficios-dt-elite.png" alt="Elite tier" />
                            </div>
                        </div>
                        <div class="cardContent">
                            <div class="cardImage">
                                <img src="https://assetsstatic.cosentino.com/ImagesCommunityCosentinoWe/myRewards/beneficios-dt-premium.png" alt="Premium tier" />
                            </div>
                            <div class="cardDescription backPremium">
                                <div class="typography-title-l">
									{{ 'rewards.PREMIUM' | translate }}
								</div>
                                <div class="typography-body-l-regular">
									{{ 'rewards.Benefits_premium_Fabricator' | translate }}
								</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    <!-- What benefits do I receive? -->
	<div class="sectionContainer">
		<div class="headerSection">
			<div class="typography-title-l" >
				{{'benefits_we.que_beneficios_obtengo' | translate }}
			</div>
		</div>
        <div class="typography-body-l-regular subtitleSection4">
            <span innerHTML="{{'benefits_we.know_some_of_the_benefits_you_can_access_as_a_member_of' | translate }}"></span>
        </div>
        <div class="typography-body-l-regular subtitleSection4">
            {{'benefits_we.te_mostramos_una_t_p' | translate }}
        </div>
		<app-table-rewards class="tableRewards"></app-table-rewards>
	</div>

    <!-- Get your benefits -->
	<div class="sectionContainer gridBenefits">
        <div class="headerSection">
            <div class="typography-title-l">
                {{ 'rewards.Consigue_beneficios_c' | translate }}
            </div>
        </div>
        <div class="typography-body-l-regular subtitleSection4">{{ 'rewards.Tu_colaboraci_n_y' | translate }} <br> {{ 'benefits_we.haz_valer_tus' | translate }}</div>
        <app-table-information-rewards
            [eliteStatus]="eliteStatus"
            [countryWarehouse]="countryWarehouse">
        </app-table-information-rewards>
	</div>
</div>
